import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { ApiClient } from '@pw-tech/web-sdk';
import { useMutation } from '@tanstack/react-query';

export const useInitiatePayment = () => {
  const { isLoading, isPending, error, mutate, mutateAsync } = useMutation(
    [API_CACHE_KEYS.INITIATE_PAYMENT],
    (body: any) => {
      return ApiClient.post(API_PATHS.INITIATE_PAYMENT, body);
    }
  );

  return {
    error,
    isLoading,
    isPending,
    mutate,
    mutateAsync,
  };
};
